module.exports = __webpack_public_path__ + "static/media/train13.91641a2c.png";